/**
 * „Musik ohne Probestück“ — der Schalter je Konto. (11.10.2026, Ticket 3077)
 *
 * Martin sagte zweimal, er wolle keine Probestücke mehr („bitte keine Vorschau mehr, weil es sowieso anders klingt“,
 * „ich brauche die Probelieder nicht“) — und ein Tipp auf die Vorschlagskarte erzeugte trotzdem eins. Eine Aussage im
 * Gespräch hält nur bis zum nächsten Zug; dieser Schalter hält sie fest.
 *
 * EIN Besitzer für die Regel, die Server (tools/generate_music.ts), Einstellungen und Zuruf
 * (shared/einstellung-aendern.ts) gleich rechnen müssen (Muster shared/morse-konto.ts):
 *
 *   - Kontowert in `users.settings`, Vorgabe AUS (das Probestück bleibt, wie es seit dem 07.10. ist);
 *   - ist er an, gilt `ohne_probe` für JEDEN Vorschlag des Kontos von selbst, und es gibt kein Probestück
 *     (auch dann nicht, wenn eine alte Karte oder das Modell eins verlangt);
 *   - das Ja zum Lied bleibt: ein Lied entsteht nie ohne seinen Knopf oder sein Wort, und es zählt ins Kontingent.
 */

/** Der Schlüssel in den Einstellungen des Kontos. */
export const MUSIK_OHNE_PROBE_FELD = "musikOhneProbe";

/** Ist der Schalter an? Nur ein ausdrückliches `true` zählt. Rein. */
export function musikOhneProbeAn(wert: unknown): boolean {
  return wert === true;
}

/** Der Schalter aus den rohen Einstellungen des Kontos (JSON). Wirft nie; unlesbar heißt aus. */
export function musikOhneProbeAusJson(einstellungenJson: string | null | undefined): boolean {
  try {
    if (!einstellungenJson) return false;
    const roh: unknown = JSON.parse(einstellungenJson);
    return typeof roh === "object" && roh !== null && !Array.isArray(roh)
      ? musikOhneProbeAn((roh as Record<string, unknown>)[MUSIK_OHNE_PROBE_FELD])
      : false;
  } catch {
    return false;
  }
}
